import {
  Component
} from "react";
import {
  withTranslation
} from "react-i18next";
import AppUI from '../../../../dictionaries/AppUI.dic';
import {
  Arr
} from '../../../../lib/Array.lib';
import {
  YES
} from '../../../../lib/Boolean.lib';
import {
  MATERIAL_ICON_NAME__EYE
} from '../../../../lib/constants/MaterialIconName.dic';
import Core from "../../../../lib/Core";
import Definition, {
  EMPLOYER_SUBMISSION_METHOD__ATS
} from "../../../../lib/Definition";
import {
  EMPLOYER__SCHEDULING__EMPLOYER_LINK,
  EMPLOYER__SCHEDULING__EMPLOYER_MANUAL,
  EMPLOYER__SCHEDULING__TEN_BY_TEN
} from '../../../../lib/Employer';
import {
  Obj
} from '../../../../lib/Object.lib';
import Chips from "../../../Forms/Chips";
import {
  JOB_SECTION__EMPLOYER__ADDITIONAL_INFO,
  JOB_SECTION__INTERVIEW_PROCESSES,
  JOB_SECTION__PUBLIC_NOTES, openJobView
} from '../../../Jobs/Card/JobDetails';
import {
  THEME__VARIANT__STANDARD
} from '../../../Layout/Libraries/Theme.lib';
import Autocomplete from '../../../Layout/Wrappers/Autocomplete';
import Box from '../../../Layout/Wrappers/Box';
import Checkbox from '../../../Layout/Wrappers/Checkbox';
import Col from "../../../Layout/Wrappers/Col";
import DatePicker from '../../../Layout/Wrappers/DatePicker';
import Divider from '../../../Layout/Wrappers/Divider';
import Fieldset from '../../../Layout/Wrappers/Fieldset';
import Icon from '../../../Layout/Wrappers/Icon';
import InputNumber from '../../../Layout/Wrappers/InputNumber';
import Menu from '../../../Layout/Wrappers/Menu';
import RadioGroup from '../../../Layout/Wrappers/RadioGroup';
import RichTextBox from "../../../Layout/Wrappers/RichTextBox";
import Row from "../../../Layout/Wrappers/Row";
import TextField from '../../../Layout/Wrappers/TextField';
import Title from '../../../Layout/Wrappers/Title';
import {
  Label
} from '../../../Layout/Wrappers/Typography';
import {
  PrescreenQuestionsEdit
} from '../../../PrescreenQuestions/PrescreenQuestionsSection';
import SectionAtsSettings from '../../EmployerSettings/SectionAtsSettings';
import InternalSubmissionInstructions from '../Forms/InternalSubmissionInstructions';

class Process extends Component {
  render() {
    const EmployerEditController = this.props.parent;
    const { t } = this.props;
    const { state } = EmployerEditController;
    const { submissionMethods = [] } = state;
    const locationTags = Definition.get("location");
    return (
      <div className="p-1">
        <div className="p-2 f-xl fw-500">
          PROCESS
        </div>

        <Row>

          <Col>

            <Chips
              name="employerSubmissionMethod"
              label={<label>Submission Method(s)</label>}
              sub="Please select all the submission methods your are interested in"
              values={submissionMethods}
              onChange={submissionMethods => {
                EmployerEditController.setState({ submissionMethods });
              }}
            />

          </Col>

          <Fieldset
            title={
              <>Who will primarily schedule interviews?</>
            }
            subtitle={
              <>If employer link is selected, the auto reminder will prompt the candidate to select a time from the booking link. Otherwise, ask the candidate to provide availability</>
            }
          >
            <Menu dropdown
              name="scheduling"
              value={EmployerEditController.state.scheduling}
              onChange={(scheduling) => EmployerEditController.setState({ scheduling })}
              options={[
                EMPLOYER__SCHEDULING__EMPLOYER_MANUAL,
                EMPLOYER__SCHEDULING__EMPLOYER_LINK,
                EMPLOYER__SCHEDULING__TEN_BY_TEN
              ]}
            />
          </Fieldset>

        </Row>

        <SectionAtsSettings
          acl={
            YES(state.id) &&
            submissionMethods.includes(EMPLOYER_SUBMISSION_METHOD__ATS)
          }
          employerId={state.id}
          onChange={EmployerEditController.updateState}
        />

        <Row className='mt-3'>
          <InternalSubmissionInstructions
            entity={EmployerEditController.state}
            onChange={async (update) => new Promise((resolve) => EmployerEditController.setState(update, resolve))}
            autoSave={false}
          />
        </Row>

        <PrescreenQuestionsEdit Controller={EmployerEditController} />

        <Fieldset
          title='Interview Process'
          subtitle={
            <>This generic employer interview process will be shown above the job-specific interview process for all jobs</>
          }
          info={AppUI.publicInfo.tooltip}
          infoIconName={MATERIAL_ICON_NAME__EYE}
          infoProps={{
            onClick: openJobView({
              jobId: Obj(Arr(EmployerEditController.state.jobs)[0]).id,
              sectionName: JOB_SECTION__INTERVIEW_PROCESSES
            })
          }}
        >
          <RichTextBox
            name="interviewProcess"
            value={EmployerEditController.state.interviewProcess}
            onChange={interviewProcess =>
              EmployerEditController.setState({ interviewProcess })
            }
          />
        </Fieldset>

        <Fieldset
          acl={Core.isAdminOrTrusted()}
          title={
            <>Hiring Priority</>
          }
          info={Core.isAdmin() && AppUI.publicInfo.tooltip}
          infoIconName={MATERIAL_ICON_NAME__EYE}
          infoProps={{
            onClick: Core.isAdmin() && openJobView({
              jobId: Obj(Arr(EmployerEditController.state.jobs)[0]).id,
              sectionName: JOB_SECTION__EMPLOYER__ADDITIONAL_INFO
            })
          }}
        >
          <RichTextBox
            name="additionalInfo"
            value={EmployerEditController.state.additionalInfo}
            onChange={additionalInfo =>
              EmployerEditController.setState({ additionalInfo })
            }
          />
        </Fieldset>

        <Row className='mt-3'>
          <Col>
            <label>How did you hear of us?</label>
            <Autocomplete
              role='EmployerReference'
              placeholder="Enter a Keyword"
              options={
                [
                  'Social Media',
                  'News',
                  'Ads',
                  'Other',
                ]
              }
              value={
                EmployerEditController.state.reference
              }
              onSelect={
                (reference) => EmployerEditController.setState({
                  reference
                })
              }
            />
          </Col>
          <Col>
            <label>
              Other Recruiting agencies / services that you are using?
            </label>
            <TextField
              name="recruitingAgencies"
              value={EmployerEditController.state.recruitingAgencies}
              onChange={(ev, recruitingAgencies) =>
                EmployerEditController.setState({ recruitingAgencies })
              }
              variant={THEME__VARIANT__STANDARD}
              maxRows={5}
              multiLine
              fullWidth
              className='mt-05'
            />
          </Col>
        </Row>

        <Row>
          <Fieldset
            title={
              <>Expected Resume Review Response Time</>
            }
            fullWidth={false}
          >
            <div className='d-flex flex-align-left-center'>
              <Icon icon='access_time' className='mr-1' xl />
              <InputNumber
                name="expectedResumeResponseTime"
                value={EmployerEditController.state.expectedResumeResponseTime}
                onChange={(expectedResumeResponseTime) =>
                  EmployerEditController.setState({
                    expectedResumeResponseTime,
                  })
                }
                style={{ width: "calc(100% - 30px)" }}
                units='hrs'
              />
            </div>
          </Fieldset>
          <Fieldset
            title={
              <>Expected Scheduling Response Time</>
            }
            fullWidth={false}
          >
            <div className='d-flex flex-align-left-center'>
              <Icon icon='access_time' className='mr-1' xl />
              <InputNumber
                name="expectedSchedulingResponseTime"
                value={EmployerEditController.state.expectedSchedulingResponseTime}
                onChange={(expectedSchedulingResponseTime) =>
                  EmployerEditController.setState({
                    expectedSchedulingResponseTime,
                  })
                }
                style={{ width: "calc(100% - 30px)" }}
                units='hrs'
              />
            </div>
          </Fieldset>
        </Row>

        <Row>
          <Fieldset
            title={
              <>Expected Screen Feedback Response Time</>
            }
            fullWidth={false}
          >
            <div className='d-flex flex-align-left-center'>
              <Icon icon='access_time' className='mr-1' xl />
              <InputNumber
                name="expectedScreenResponseTime"
                value={EmployerEditController.state.expectedScreenResponseTime}
                onChange={(expectedScreenResponseTime) =>
                  EmployerEditController.setState({
                    expectedScreenResponseTime,
                  })
                }
                onFocus={(ev) => ev.target.select()}
                style={{ width: "calc(100% - 30px)" }}
                units='hrs'
              />
            </div>
          </Fieldset>
          <Fieldset
            title={
              <>Expected Onsite Feedback Response Time</>
            }
            fullWidth={false}
          >
            <div className='d-flex flex-align-left-center'>
              <Icon icon='access_time' className='mr-1' xl />
              <InputNumber
                name="expectedOnsiteResponseTime"
                value={EmployerEditController.state.expectedOnsiteResponseTime}
                onChange={(expectedOnsiteResponseTime) =>
                  EmployerEditController.setState({
                    expectedOnsiteResponseTime,
                  })
                }
                onFocus={(ev) => ev.target.select()}
                style={{ width: "calc(100% - 30px)" }}
                units='hrs'
              />
            </div>
          </Fieldset>
        </Row>

        <div
          className="green-block rounded py-1 mt-3"
          style={{ backgroundColor: colors.green.light }}
        >
          <Row>
            <Col fullWidth>
              <Title className='m-0'>
                For 10 by 10 use only
              </Title>
            </Col>
          </Row>

          <Box row className='flex-align-left-top hover-bg'>
            <Fieldset
              title={
                <Label className='tt-none'>
                  Service Level Agreement
                </Label>
              }
            >
              <Checkbox
                label='Identify SLA Violations'
                checked={EmployerEditController.state.slaContext.enabled}
                onChange={(event, enabled) => {
                  EmployerEditController.setState({
                    slaContext: {
                      ...EmployerEditController.state.slaContext,
                      enabled
                    }
                  });
                }}
                className='flex-1 mr-1'
              />
            </Fieldset>
            <Fieldset
              title='Expected response time'
            >
              <Box row>
                <Icon icon='access_time' className='mr-1' xl />
                <InputNumber
                  value={EmployerEditController.state.slaContext.hours}
                  onChange={(hours) => {
                    EmployerEditController.setState({
                      slaContext: {
                        ...EmployerEditController.state.slaContext,
                        hours
                      }
                    });
                  }}
                  onFocus={(event) => event.target.select()}
                  units='hrs'
                />
              </Box>
            </Fieldset>
          </Box>

          <Row className='mt-3'>
            <Col fullWidth>
              <label>
                Additional recruiting services that employer did not mention
              </label>
              <TextField
                name="additionalRecruitingAgencies"
                value={EmployerEditController.state.additionalRecruitingAgencies}
                onChange={(ev, additionalRecruitingAgencies) =>
                  EmployerEditController.setState({
                    additionalRecruitingAgencies,
                  })
                }
                fullWidth
              />
            </Col>
          </Row>

          {/** related to story-3258 */}
          <Row className='mt-3'>
            <Col fullWidth>
              <label>{t('employer.process.location.label')}</label>
              <Menu tree multiple={false}
                value={EmployerEditController.state.location}
                onChange={(location) => {
                  EmployerEditController.setState({ location });
                }}
                options={locationTags}
                placeholder={t('employer.process.location.placeholder')}
                className="my-1"
              />
            </Col>
          </Row>
          {/** */}

          <Row className='mt-3'>
            <Col>
              <label>Current State</label>
              <RadioGroup column
                name="current_state"
                options={Definition.get("state").filter((tag) =>
                  Core.isAdminOrCoordinator()
                    ? true
                    : Definition.test("state", tag.id, /draft/)
                )}
                value={EmployerEditController.state.state}
                onChange={(event, state) => EmployerEditController.setState({ state })}
              />
            </Col>
            <Col>
              <label>Hiring Difficulty</label>
              <RadioGroup column
                name="employerHiringDifficulty"
                options={Definition.get("employerHiringDifficulty")}
                value={EmployerEditController.state.employerHiringDifficulty}
                onChange={
                  (ev, employerHiringDifficulty) => EmployerEditController.setState({ employerHiringDifficulty })
                }
              />
            </Col>
            <Col>
              <label>Flags</label>
              {Definition.get("flags").map((tag) => (
                <Checkbox
                  key={tag.id}
                  label={tag.label}
                  checked={!!~EmployerEditController.state.flags.indexOf(tag.id)}
                  onCheck={(ev, checked) => {
                    EmployerEditController.setState((state) => {
                      state = { flags: EmployerEditController.state.flags };
                      if (checked) {
                        if (!state.flags.find((id) => id === tag.id)) {
                          state.flags.push(tag.id);
                        }
                      } else {
                        state.flags = state.flags.filter((id) => id !== tag.id);
                      }
                      Core.log({ state });
                      return state;
                    });
                  }}
                />
              ))}
              <Divider />
              <Checkbox
                label="Confidential"
                checked={EmployerEditController.state.confidential}
                onCheck={(ev, confidential) =>
                  EmployerEditController.setState({ confidential })
                }
              />
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <label>Placement Fee</label>
              <div className='d-flex flex-align-left-center'>
                <TextField
                  name="placementFee"
                  type="number"
                  max={100}
                  maxLength={5}
                  value={EmployerEditController.state.placementFee}
                  onChange={(ev, placementFee) =>
                    EmployerEditController.setState({
                      placementFee: Number(
                        placementFee > 100
                          ? 100
                          : String(placementFee).slice(0, 5)
                      ),
                    })
                  }
                />
                <span className="c-black-medium">%</span>
              </div>
            </Col>
            <Col>
              <label>Guarantee</label>
              <div className='d-flex flex-align-left-center'>
                <TextField
                  name="guarantee"
                  type="number"
                  maxLength={3}
                  value={EmployerEditController.state.guarantee}
                  onChange={(ev, guarantee) =>
                    EmployerEditController.setState({
                      guarantee:
                        guarantee > 999
                          ? 999
                          : String(Math.round(guarantee)).slice(0, 3),
                    })
                  }
                />
                <span className="c-black-medium">days</span>
              </div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col fullWidth>
              <label>Additional Contract Information</label>
              <TextField
                name="additionalContractInfo"
                type="text"
                rows={1}
                rowsMax={3}
                multiLine={true}
                value={EmployerEditController.state.additionalContractInfo}
                onChange={(ev, additionalContractInfo) =>
                  EmployerEditController.setState({
                    additionalContractInfo,
                  })
                }
                fullWidth
              />
            </Col>
          </Row>

          <Fieldset
            title={
              <>Public Notes</>
            }
            subtitle=''
            info={AppUI.publicInfo.tooltip}
            infoIconName={MATERIAL_ICON_NAME__EYE}
            infoProps={{
              onClick: openJobView({
                jobId: Obj(Arr(EmployerEditController.state.jobs)[0]).id,
                sectionName: JOB_SECTION__PUBLIC_NOTES
              })
            }}
          >
            <TextField
              name="publicNotes"
              rows={5}
              rowsMax={10}
              value={EmployerEditController.state.publicNotes}
              onChange={(ev, publicNotes) => EmployerEditController.setState({ publicNotes })}
            />
          </Fieldset>

          <Row className='mt-3'>
            <Col fullWidth>
              <label>Internal Privacy Notes not visible to recruiters</label>
              <TextField
                name="internalNotes"
                rows={5}
                rowsMax={10}
                value={EmployerEditController.state.internalNotes}
                onChange={(ev, internalNotes) =>
                  EmployerEditController.setState({ internalNotes })
                }
              />
            </Col>
          </Row>
        </div>
        <Row className='mt-3'>
          <Col>
            <label>Creation Date</label>
            <DatePicker
              name="createdAt"
              value={
                EmployerEditController.state.createdAt ? new Date(EmployerEditController.state.createdAt) : null
              }
              onChange={(createdAt) => {
                EmployerEditController.setState({ createdAt: createdAt.toISOString() });
              }}
              fullWidth
            />
          </Col>
          <Col>
            <label>Last Update</label>
            <DatePicker
              name="updatedAt"
              value={
                EmployerEditController.state.updatedAt ? new Date(EmployerEditController.state.updatedAt) : null
              }
              onChange={(updatedAt) => {
                EmployerEditController.setState({ updatedAt: updatedAt.toISOString() });
              }}
              fullWidth
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <label>Closed Date</label>
            <DatePicker
              name="closeDate"
              value={
                EmployerEditController.state.closeDate ? new Date(EmployerEditController.state.closeDate) : null
              }
              onChange={(closeDate) => {
                EmployerEditController.setState({ closeDate: closeDate.toISOString() });
              }}
              fullWidth
            />
          </Col>
        </Row>
      </div >
    );
  }
}

/* EXPORTS ==================================== */

export default withTranslation()(Process);

/* ============================================ */
